import { types, actions } from './requests'
export const DELETEMACHINETYPE_TYPES = {
    ...types('DELETEMACHINETYPE'),
}
export const DELETEMACHINETYPE_ACTIONS = {
    ...actions('DELETEMACHINETYPE'),
}
